import React, { ChangeEvent, InputHTMLAttributes } from 'react';
import { SwitchWrapper } from './components/SwitchWrapper';
import { SwitchLabel } from './components/SwitchLabel';
import { StyledSwitch } from './components/StyledSwitch';
import { LabelText } from './components/LabelText';
import { InputWrapper } from './components/InputWrapper';
import { Text } from '@televet/kibble-ui/build/components/Text';

interface IProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  name: string;
  label: string;
  className?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  hasPermission?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>, value: boolean) => void;
}

const Switch = ({
  name,
  label,
  className,
  checked,
  defaultChecked,
  disabled,
  hasPermission = true,
  onChange,
  ...rest
}: IProps): JSX.Element => {
  const selected = checked || defaultChecked || false;
  const checkClass = selected ? 'checked' : '';

  const onSelect = (e: ChangeEvent<HTMLInputElement>): void => {
    const { checked } = e.target;
    onChange(e, checked);
  };

  return (
    <InputWrapper>
      {hasPermission ? (
        <>
          <SwitchWrapper className={`${checkClass}`}>
            <StyledSwitch
              type="checkbox"
              name={name}
              className={className}
              checked={selected}
              disabled={disabled}
              onChange={onSelect}
              aria-label={name}
              data-testid="checkbox-switch"
              {...rest}
            />
            <SwitchLabel />
          </SwitchWrapper>
          <LabelText>{label}</LabelText>
        </>
      ) : (
        <Text size="sm">{label}</Text>
      )}
    </InputWrapper>
  );
};

export default Switch;
